// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2V_pd","label":"SetPasswdForm_label__1f9fJ"};